<div class="wrapper">
  <app-header></app-header>

  <div class="main pt-1">
    <div class="h-100 p-relative">
      <div class="h-100 p-3 overflow-scroll">
        <div
          class="d-flex w-100 mb-3"
          style="gap: 0.5rem"
          *ngIf="stepsList?.length > 1"
        >
          <div
            *ngFor="let step of stepsList; let i = index"
            class="w-100"
            style="height: 0.25rem"
            [style.background-color]="
              i == currentStepIndex ? '#006bd3' : '#d6d3d1'
            "
          ></div>
        </div>
        <h3 *ngIf="issueName" style="color: #006bd3">
          {{ issueName[languageIndex] }}
        </h3>

        <div *ngIf="step?.showIntro">
          <h1 style="font-size: 24px" class="text-black">
            {{ translations['fix_label'] }}
          </h1>
          <p>{{ translations['info_text'] }}</p>
          <p>{{ translations['step_message'] }}</p>
        </div>

        <div *ngIf="!step?.showIntro">
          <div *ngIf="step?.steps" style="font-weight: 400; font-size: 21px">
            {{ step?.steps[0]?.label[languageIndex] }}
          </div>
        </div>

        <div *ngIf="step?.question">
          <div style="font-weight: 400; font-size: 21px">
            {{ step?.label[languageIndex] }}
          </div>
        </div>

        <div class="image-grid pt-3">
          <div
            *ngFor="let image of step?.images"
            class="image"
            style="position: relative"
          >
            <img
              src="{{ image?.url }}"
              alt="Image 1"
              (click)="openImage(image?.url)"
              *ngIf="!image?.video"
            />
            <img
              src="{{ image?.url }}"
              alt="Image 1"
              (click)="openVideo(image?.video)"
              *ngIf="image?.video"
            />

            <div
              style="
                position: absolute;
                background-color: #006bd3;
                top: 0;
                height: 40px;
                width: 40px;
                padding: 5px;
              "
              *ngIf="!image?.video"
            >
              <img
                style="height: 20px; width: 20px"
                src="assets/images/icon/zoom.svg"
                alt="Image 1"
              />
            </div>

            <div
              style="
                position: absolute;
                background-color: #006bd3;
                top: 40%;
                left: 40%;
                padding: 4px;
                height: 45px;
                width: 45px;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
              *ngIf="image?.video"
              (click)="openVideo(image?.video)"
            >
              <img src="assets/images/icon/play-icon.png" alt="play" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div
      *ngIf="step?.steps"
      style="display: flex; justify-content: space-evenly"
    >
      <ul
        style="list-style-type: none; padding: 0; margin: 0"
        *ngFor="let option of step?.steps[0]?.options"
      >
        <li
          *ngIf="option?.icon == 'check' && !(option?.label == 'Start')"
          class="text-center"
        >
          <div
            class="button2"
            style="background-color: #00a653"
            (click)="selection(option)"
          >
            <!-- {{option?.steps[0].}} -->
            <span style="fill: white">
              <img class="yes-icon" src="assets/images/icon/yes.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li
          class="button"
          *ngIf="option?.icon == 'check' && option?.label == 'Start'"
          (click)="start(option)"
          class="text-center"
        >
          <span>
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li *ngIf="option?.icon == 'question'" class="text-center">
          <div class="mb-3 mt-3">
            <span
              class="button3"
              style="fill: #ffffff"
              style="background-color: #f5af00"
              (click)="requestHelp(option)"
            >
              <img style="width: 25px" src="assets/images/icon/question.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li *ngIf="option?.icon == 'cross'" class="text-center">
          <div
            class="button2"
            (click)="selection(option)"
            style="background-color: #cc3300"
          >
            <span style="fill: #006bd3">
              <img style="width: 25px" src="assets/images/icon/no.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>
      </ul>
    </div>

    <div *ngIf="!step?.steps" style="display: flex; gap: 0.5rem">
      <ul
        style="list-style-type: none; padding: 0; margin: 0; width: 100%"
        *ngFor="let option of step?.options"
      >
        <li
          class="button"
          *ngIf="
            option?.icon == 'check' && option?.option == 'troubleshooting.start'
          "
          (click)="start(option)"
        >
          {{ option?.label[languageIndex] }}
        </li>

        <li
          class="button"
          *ngIf="
            option?.icon == 'check' &&
            option?.option == 'troubleshooting.resolved'
          "
          (click)="resolved()"
        >
          {{ option?.label[languageIndex] }}
        </li>

        <li
          class="button"
          *ngIf="option?.icon == 'chevronRight'"
          (click)="next(option)"
        >
          {{ option?.label[languageIndex] }}
        </li>

        <li
          class="button"
          *ngIf="option?.icon == 'truck'"
          (click)="requestHelp(option)"
        >
          {{ translations['help_button'] }}
        </li>
      </ul>
    </div>
  </div>

  <div class="popup" *ngIf="popupDetails?.showPopup">
    <div class="imageContainer">
      <div class="closeIconContainer">
        <div class="closeIcon" (click)="closePopup()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            aria-hidden="true"
            class="h-8 w-8 fill-white"
          >
            <path
              fill-rule="evenodd"
              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </div>
      </div>
      <div *ngIf="popupDetails?.isImage">
        <img class="image" src="{{ popupDetails?.url }}" />
      </div>
      <div *ngIf="!popupDetails?.isImage">
        <iframe
          [src]="popupDetails?.url | safe"
          frameborder="0"
          allowfullscreen
          allow="autoplay"
        >
        </iframe>
      </div>
    </div>
  </div>
</div>
